/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/config/index.js
 */

import {loadLanguageAsync} from './i18n-setup'

export default {
    i18nAutoLoad(Vue, option) {
        if (option && option.router && 'beforeEach' in option.router)
            option.router.beforeEach((to, from, next) => {
                if (to.params && to.params.lang) {
                    const lang = to.params.lang
                    loadLanguageAsync(lang).then(() => next())
                } else
                    next()
            })
    }
}
